import Link from "next/link";
import React from "react";

const Evaluation = () => {
  return (
    <div className="bg-gray-100 py-4 mt-8">
      <div className="container mx-auto flex flex-col justify-center items-center py-2 gap-6 md:mt-5 mt-0 px-3 md:px-0">
        <h2 className="text-2xl text-primary font-medium text-center">
          Get Free Evaluation For your Bungalow
        </h2>
        <p className="text-base leading-7 text-center md:w-5/6 w-full">
          As certified active real estate agents, we are always in tune with the
          latest market trends and have a deep understanding of bungalow sales.
          Our free in-home evaluation offers a comprehensive analysis of your
          property and helps you understand what you can expect when selling
          your house. We also provide valuable tips on how to get top dollar for
          your home and sell it faster than the competition. If {"you're"}{" "}
          thinking of selling your bungalow, {"don't"} hesitate to give us a
          call today to learn more. Our team is here to help you navigate the
          process and achieve the best possible outcome.
        </p>
        <div className="pb-6">
          <Link  href="/homeevaluation">
            <a className="bg-primary rounded-md text-white px-7 py-2 text-sm">
              Get Free Evaluation
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Evaluation;
